import { Component, Input } from '@angular/core';
import { VideoAssetMetadata } from '@models/Sessions/Idea/VideoProject';
import { formatDuration } from 'date-fns/formatDuration';
import { millisecondsToSeconds } from 'date-fns/millisecondsToSeconds';

@Component({
  selector: 'app-video-asset-metadata',
  standalone: true,
  imports: [],
  templateUrl: './video-asset-metadata.component.html',
  styleUrl: './video-asset-metadata.component.scss',
})
export class VideoAssetMetadataComponent {
  @Input() metadata?: VideoAssetMetadata;

  get duration(): string | undefined {
    if (!this.metadata) {
      return undefined;
    }
    return formatDuration(
      {
        seconds: millisecondsToSeconds(this.metadata.duration),
      },
      {
        format: ['hours', 'minutes', 'seconds'],
        delimiter: '',
        locale: {
          formatDistance: (token, count) => {
            switch (token) {
              case 'xHours':
                return `${count}h`;
              case 'xMinutes':
                return `${count}m`;
              case 'xSeconds':
                return `${Math.ceil(count)}s`;
              default:
                return String(count);
            }
          },
        },
      },
    );
  }
}
